import { LobbyStatus, LobbyTypeEnum } from '../../enums';
import {
	IsBoolean,
	IsDate,
	IsEnum,
	IsNotEmpty,
	IsNumber,
	IsObject,
	IsOptional,
	IsString,
	IsUUID,
	ValidateIf,
	ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

export class LobbyDetailDto {
	@IsOptional()
	@IsString()
	id?: string;

	@IsString()
	@IsNotEmpty()
	header: string;

	@IsString()
	@IsNotEmpty()
	content: string;

	@IsNumber()
	@IsNotEmpty()
	@Type(() => Number)
	order: number;
}

export class CreateLobbyDto {
	@ValidateIf((o) => o.is_private === true)
	@IsString()
	access_password?: string;

	@IsOptional()
	@IsString()
	description?: string;

	@IsUUID()
	@IsNotEmpty()
	event_id: string;

	@IsOptional()
	@IsBoolean()
	is_default?: boolean;

	@IsOptional()
	@IsBoolean()
	is_private?: boolean;

	/** Classic lobbies only: also offer the 25Q Live (bingo) mode. */
	@IsOptional()
	@IsBoolean()
	is_bingo?: boolean;

	@IsString()
	@IsNotEmpty()
	name: string;

	@IsOptional()
	@IsEnum(LobbyStatus)
	status?: LobbyStatus;

	@IsOptional()
	@IsEnum(LobbyTypeEnum)
	type?: LobbyTypeEnum;

	@IsOptional()
	@IsNumber()
	@Type(() => Number)
	market_open_delay?: number;

	@IsOptional()
	@IsString()
	banner_url?: string;

	@IsOptional()
	@IsObject()
	header_img_variants?: object;

	@IsOptional()
	@IsString()
	header_img_parent_id?: string;

	@IsOptional()
	@IsObject()
	logo_img_variants?: object;

	@IsOptional()
	@IsString()
	logo_img_parent_id?: string;

	@IsOptional()
	@IsObject()
	sponsor?: object;

	@IsString()
	info: string;

	@IsOptional()
	@IsString()
	prize?: string;

	@IsOptional()
	@IsString()
	image_url?: string;

	@IsOptional()
	@IsString()
	image_id?: string;

	@IsOptional()
	@IsObject()
	img_variants?: object;

	@IsOptional()
	@IsString()
	img_parent_id?: string;

	@IsOptional()
	@IsBoolean()
	is_chat_closed?: boolean;

	@IsOptional()
	@ValidateNested({ each: true })
	@Type(() => LobbyDetailDto)
	details?: LobbyDetailDto[];

	@IsOptional()
	@Type(() => Date)
	@IsDate()
	game_start_date?: Date;
}
